"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Login";

export default {
  doLogin: function (credentials) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/DoLogin`, credentials).result.then(
        ({ data }) => {
          resolve({
            token: data,
            success: !!data
          });
        }
      );
    });
  },
  doLogout: function () {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/DoLogout`).result.then(() => {
        resolve();
      });
    });
  },
  doLoginSSO: function (request) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/DoLoginSSO`, request).result.then(
        ({ data }) => {
          resolve({
            token: data,
            success: !!data
          });
        }
      );
    });
  }
};
